<div class="container-fluid" style="max-width: 1200px;">
    <h1 class="m-3 display-6 vm-container-header">User Management</h1>

    <div class="m-3 p-2 bg-body-light rounded-3 shadow">
        <div class="m-2">
            <form>
                <div class="mb-3 row align-items-center">
                    <div class="col-sm-auto">
                        <select (change)="this.onCustomerChange($event)" aria-label="Select a customer" class="form-select">
                            <option selected>Select a Customer</option>
                            @for (entity of this.customers; track entity.id; ) {
                                <option value="{{ entity.code }}">{{ entity.name }}</option>
                            }
                        </select>
                    </div>
                </div>
            </form>

            @if (!!this.customerCode && ((this.total$ | async) ?? 0) > 0) {
                <table class="table table-striped table-hover">
                    <caption>
                        <div class="container-fluid">
                            <div class="row justify-content-center align-self-center">
                                <div class="col align-self-center">
                                    {{ this.service.customerUserCount() }} of {{ this.service.maxNumberOfUsers() }} Total Users
                                </div>
                                <div class="col text-end">
                                    <i class="btn btn-sm btn-outline-primary bi bi-person-plus"
                                       (click)="onAddUser()"></i>
                                </div>
                            </div>
                        </div>
                    </caption>

                    <thead>
                    <tr>
                        <th (sort)="this.onSort($event)" scope="col" sortable="fullName">Name</th>
                        <th (sort)="this.onSort($event)" scope="col" sortable="email">Email</th>
                        <th (sort)="this.onSort($event)" scope="col" sortable="isAdmin" class="text-center">Admin</th>
                        <th (sort)="this.onSort($event)" scope="col" sortable="isEnabled" class="text-center">Active</th>
                        <th scope="col"></th>
                    </tr>
                    </thead>

                    <tbody class="table-group-divider">
                        @for (element of this.users$ | async; track element.id) {
                            <tr>
                                <td class="align-middle">{{ element.fullName }}</td>
                                <td class="align-middle">{{ element.email }}</td>
                                <td class="align-middle text-center">
                                    @if (element.isAdmin) {
                                        <i class="bi bi-check-lg text-success status"></i>
                                    } @else {
                                        <i class="bi bi-x text-danger status"></i>
                                    }
                                </td>
                                <td class="align-middle text-center">
                                    @if (element.isEnabled) {
                                        <i class="bi bi-check-lg text-success status"></i>
                                    } @else {
                                        <i class="bi bi-x text-danger status"></i>
                                    }
                                </td>
                                <td class="align-middle text-end">
                                    <div class="btn-group">
                                        <i class="btn btn-sm btn-outline-primary bi bi-pencil"
                                           (click)="onEdit(element)"></i>
                                        <i class="btn btn-sm btn-outline-primary bi bi-box-seam"
                                           title="Product Groups"
                                           (click)="onManageProductGroups(element)"></i>
                                        <button type="button" class="btn btn-sm btn-outline-primary bi bi-clock-history"
                                                title="View this user's activity"
                                                [attr.aria-label]="'Activity of ' + element.fullName"
                                                (click)="onActivity(element)"></button>
                                        @if (element.canResendVerification) {
                                            @let resendDisabled = !element.isEnabled || element.disabledInCognito;
                                            <i class="btn btn-sm bi bi-envelope-arrow-up"
                                               [class.btn-outline-primary]="!resendDisabled"
                                               [class.btn-outline-secondary]="resendDisabled"
                                               [style.cursor]="resendDisabled ? 'not-allowed' : null"
                                               [attr.aria-disabled]="resendDisabled"
                                               [title]="resendDisabled ? 'Verification is still pending, but the email cannot be sent while this user is disabled.' : 'Resend Verification Email'"
                                               (click)="!resendDisabled && confirmResendVerification(element)"></i>
                                        }
                                        <i class="btn btn-sm btn-outline-danger bi-trash"
                                           (click)="confirmDeleteUser(element)"></i>
                                    </div>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            }

            @if (!!this.customerCode && ((this.total$ | async) ?? 0) > 0) {
                <app-table-pager [total]="(this.total$ | async)!" [(page)]="this.service.page" [(pageSize)]="this.service.pageSize" />
            }

            @if (!this.customerCode) {
                <div class="card text-center bg-info-subtle border border-info rounded p-3 m-5">
                    <div class="card-body">
                        <i class="bi bi-info-circle-fill me-2"></i>Select a customer to see its users.
                    </div>
                </div>
            }

            @if (!!this.customerCode && ((this.total$ | async) ?? 0) == 0 && !(this.globalService.waitOverlayIsVisible$ | async)) {
                <div class="card text-center bg-warning-subtle border border-warning rounded p-3 m-5">
                    <div class="card-body">
                        <div>
                            <i class="bi bi-exclamation-triangle-fill me-2"></i>
                            No users found.
                        </div>

                        <div class="btn btn-primary mt-5" (click)="onAddUser()">
                            <i class="bi bi-person-plus me-2"></i>
                            Click here to add a user
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>

    <ng-template #addUserModal>
        <div class="modal-header">
            <h1 class="modal-title fs-5" id="addUserModalLabel">
                Add User
            </h1>
            <button (click)="onAddUserDismiss()" type="button" class="btn-close" aria-label="Close"></button>
        </div>

        <form [formGroup]="addUserForm" (ngSubmit)="onAddUserSubmit()">
            <div class="modal-body container-fluid">
                <div class="row g-0">
                    <div class="form-floating col-md-12 mt-3">
                        <input type="text" class="form-control" id="addUserFullNameControl" formControlName="fullName">
                        <label for="addUserFullNameControl" class="form-label">Full Name</label>
                    </div>

                    <div class="form-floating col-md-12 mt-3">
                        <input type="text" class="form-control" id="addUserEmailControl" formControlName="email">
                        <label for="addUserEmailControl" class="form-label">Email</label>
                    </div>

                    <div class="form-floating col-md-12 mt-3">
                        <div class="form-check form-check-inline form-switch">
                            <input class="form-check-input"
                                   type="checkbox"
                                   role="switch"
                                   id="addUserIsAdminControl"
                                   formControlName="isAdmin">
                            <label class="form-check-label" for="addUserIsAdminControl">Admin</label>
                        </div>
                    </div>

                    <div class="col-md-12 mt-4">
                        <label class="form-label fw-semibold">Product Groups</label>
                        @if (this.loadingAddUserProductGroups$ | async) {
                            <div class="text-center p-3">
                                <span class="spinner-border spinner-border-sm me-2"></span> Loading product groups&hellip;
                            </div>
                        }
                        @else if (this.addUserProductGroups.length === 0) {
                            <div class="alert alert-warning rounded p-3">
                                <i class="bi bi-exclamation-triangle-fill me-2"></i>
                                This customer has no product groups; one is required to add a user.
                            </div>
                        }
                        @else {
                            <div class="callout callout-info mt-0 small">
                                <span class="badge text-bg-info" style="display: inline;">All Products</span> is a system
                                controlled product group that automatically contains all of the customer's products.
                            </div>
                            @for (group of this.addUserProductGroups; track group.id) {
                                <div class="form-check">
                                    <input class="form-check-input"
                                           type="checkbox"
                                           [id]="'add-pg-' + group.id"
                                           [checked]="this.isAddUserProductGroupSelected(group.id)"
                                           (change)="this.onToggleAddUserProductGroup(group.id, $event)">
                                    <label class="form-check-label" [for]="'add-pg-' + group.id">
                                        {{ group.name }}
                                        @if (group.isAllProducts) {
                                            <span class="badge text-bg-info ms-2">All Products</span>
                                        }
                                    </label>
                                </div>
                            }
                            @if (this.addUserSelectedGroupIds.size === 0) {
                                <div class="text-danger small mt-2">
                                    <i class="bi bi-exclamation-triangle-fill me-1"></i>
                                    Select at least one product group.
                                </div>
                            }
                        }
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button [disabled]="savingData || !this.canSubmitAddUser" type="submit" class="btn btn-primary">
                    @if (savingData) {
                        <span class="spinner-border spinner-border-sm me-1"></span>
                    }
                    Save
                </button>
                <button (click)="onAddUserDismiss()" type="button" class="btn btn-secondary">Close</button>
            </div>
        </form>
    </ng-template>

    <ng-template #editModal>
        <div class="modal-header">
            <h1 class="modal-title fs-5" id="editModalLabel">
                Edit User
            </h1>
            <button (click)="onEditDismiss()" type="button" class="btn-close" aria-label="Close"></button>
        </div>

        <form [formGroup]="editForm" (ngSubmit)="onSubmit()">
            <div class="modal-body container-fluid">
                <div class="row g-0">
                    <div class="form-floating col-md-12 mt-3">
                        <input type="text" class="form-control" id="fullNameControl" formControlName="fullName">
                        <label for="fullNameControl" class="form-label">Full Name</label>
                    </div>

                    <div class="form-floating col-md-12 mt-3">
                        <div class="form-check form-check-inline form-switch">
                            <input class="form-check-input"
                                   type="checkbox"
                                   role="switch"
                                   id="isAdminControl"
                                   formControlName="isAdmin">
                            <label class="form-check-label" for="isAdminControl">Admin</label>
                        </div>

                        <div class="form-check form-check-inline form-switch">
                            <input class="form-check-input"
                                   type="checkbox"
                                   role="switch"
                                   id="isEnabledControl"
                                   formControlName="isEnabled">
                            <label class="form-check-label" for="isEnabledControl">Active</label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button [disabled]="savingData" type="submit" class="btn btn-primary">
                    @if (savingData) {
                        <span class="spinner-border spinner-border-sm me-1"></span>
                    }
                    Save
                </button>
                <button (click)="onEditDismiss()" type="button" class="btn btn-secondary">Close</button>
            </div>
        </form>
    </ng-template>

    <ng-template #productGroupsModal>
        <div class="modal-header">
            <h1 class="modal-title fs-5" id="productGroupsModalLabel">
                Product Groups &mdash; {{ this.productGroupsUser?.fullName }}
            </h1>
            <button (click)="closeProductGroupsModal()" type="button" class="btn-close" aria-label="Close"></button>
        </div>

        <div class="modal-body container-fluid">
            @if (this.loadingProductGroups$ | async) {
                <div class="text-center p-4">
                    <span class="spinner-border spinner-border-sm me-2"></span> Loading product groups&hellip;
                </div>
            }
            @else if (this.availableProductGroups.length === 0) {
                <div class="alert alert-warning rounded p-3 m-3">
                    <i class="bi bi-exclamation-triangle-fill me-2"></i>
                    This customer has no product groups.
                </div>
            }
            @else {
                <div class="callout callout-info mt-0 small">
                    <span class="badge text-bg-info" style="display: inline;">All Products</span> is a system controlled
                    product group that automatically contains all of the customer's products as they are created or deleted.
                </div>
                @for (group of this.availableProductGroups; track group.id) {
                    <div class="form-check">
                        <input class="form-check-input"
                               type="checkbox"
                               [id]="'pg-' + group.id"
                               [checked]="this.isProductGroupSelected(group.id)"
                               (change)="this.onToggleProductGroup(group.id, $event)">
                        <label class="form-check-label" [for]="'pg-' + group.id">
                            {{ group.name }}
                            @if (group.isAllProducts) {
                                <span class="badge text-bg-info ms-2">All Products</span>
                            }
                        </label>
                    </div>
                }
                @if (!this.canSaveProductGroups) {
                    <div class="text-danger small mt-3">
                        <i class="bi bi-exclamation-triangle-fill me-1"></i>
                        A user must be granted at least one product group.
                    </div>
                }
            }
        </div>

        <div class="modal-footer">
            <button [disabled]="savingData || !this.canSaveProductGroups || (this.loadingProductGroups$ | async)"
                    (click)="onSaveProductGroups()" type="button" class="btn btn-primary">
                @if (savingData) {
                    <span class="spinner-border spinner-border-sm me-1"></span>
                }
                Save
            </button>
            <button (click)="closeProductGroupsModal()" type="button" class="btn btn-secondary">Close</button>
        </div>
    </ng-template>

    <app-modal-confirm #confirmationModal></app-modal-confirm>
</div>
